import {BaseMobxStore} from "../../../../infrastructure/mobx/base-mobx-store";
import {LiveStreamingModuleConfig} from "./live-streaming-module.config";
import {LiveStreamingModuleState} from "./models/live-streaming-module.state";

export class LiveStreamingModuleStore extends BaseMobxStore {
  static injectables = [LiveStreamingModuleConfig, LiveStreamingModuleState];
}
